var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRuleBooking(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 66",
    style: {
      enableBackground: "new 0 0 96 66"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#757575;}\n\t.st2{opacity:4.000000e-02;fill:#757575;}\n\t.st3{opacity:0.2;fill:#757575;}\n\t.st4{fill:none;stroke:#757575;stroke-width:11.1228;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st5{fill:none;stroke:#757575;stroke-width:17.0079;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st6{fill:none;stroke:#757575;stroke-width:1.4173;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st7{fill:#B7B7B7;}\n\t.st8{opacity:0.2;}\n\t.st9{fill:none;stroke:#757575;stroke-width:11.9972;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st10{fill:none;stroke:#757575;stroke-width:1.6565;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st11{opacity:0.4;}\n\t.st12{fill:none;stroke:#A3A3A3;stroke-width:0.8344;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st13{fill:none;stroke:#A3A3A3;stroke-width:1.1829;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st14{fill:none;stroke:#757575;stroke-width:0.1152;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st15{fill:none;stroke:#47B2E5;stroke-width:0.9921;stroke-linecap:round;stroke-linejoin:round;}\n\t.st16{fill:#47B2E5;}\n\t.st17{fill:none;stroke:#A3A3A3;stroke-width:0.8491;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st18{fill:none;stroke:#A3A3A3;stroke-width:1.2038;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st19{fill:none;stroke:#757575;stroke-width:0.1172;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st20{fill:none;stroke:#A3A3A3;stroke-width:0.5607;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st21{fill:none;stroke:#A3A3A3;stroke-width:0.7949;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st22{fill:none;stroke:#757575;stroke-width:7.742018e-02;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-2393,284.6c-3.5,0-6.4-2.9-6.4-6.4V-216c0-3.5,2.9-6.4,6.4-6.4h482c3.5,0,6.4,2.9,6.4,6.4v494.2 c0,3.5-2.9,6.4-6.4,6.4H-2393z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-1911-216v494.2h-482V-216H-1911 M-1911-228.8h-482c-7.1,0-12.8,5.7-12.8,12.8v494.2 c0,7.1,5.7,12.8,12.8,12.8h482c7.1,0,12.8-5.7,12.8-12.8V-216C-1898.2-223-1903.9-228.8-1911-228.8L-1911-228.8z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -2393,
    y: -216,
    className: "st2",
    width: 482,
    height: 347.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-2393,131.8c0,0,128.1-129.1,147.5-129.1c19.5,0,73.4,37.6,93.5,37.6s121.9-103.9,159.7-103.9 c37.8,0,81.3,133.6,81.3,133.6v61.8H-2393z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: -2289.8,
    cy: -133.9,
    r: 26.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: -2288.9,
    y1: 206.2,
    x2: -2172.4,
    y2: 206.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: -2342.2,
    y1: 87.8,
    x2: -2066.7,
    y2: 87.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: -2342.2,
    cy: 206.2,
    r: 15.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: -2342.2,
    y1: 206.2,
    x2: -2333,
    y2: 212.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: -2342.2,
    y1: 206.2,
    x2: -2342.2,
    y2: 196.8
  })), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: -2132.3,
    y1: 206.2,
    x2: -2015.8,
    y2: 206.2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-1293,284.6c-3.5,0-6.4-2.9-6.4-6.4V-216c0-3.5,2.9-6.4,6.4-6.4h482c3.5,0,6.4,2.9,6.4,6.4v494.2 c0,3.5-2.9,6.4-6.4,6.4H-1293z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M-811-216v494.2h-482V-216H-811 M-811-228.8h-482c-7.1,0-12.8,5.7-12.8,12.8v494.2c0,7.1,5.7,12.8,12.8,12.8 h482c7.1,0,12.8-5.7,12.8-12.8V-216C-798.2-223-803.9-228.8-811-228.8L-811-228.8z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -1293,
    y: -216,
    className: "st2",
    width: 482,
    height: 307.6
  }), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: -1177.5,
    cy: -35.2,
    r: 23
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1226,
    y: -125.6,
    className: "st1",
    width: 17,
    height: 217.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: -900.4,
    y: -5.3,
    className: "st1",
    width: 17,
    height: 96.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1083.6,
    y: -130.7,
    transform: "matrix(6.123234e-17 -1 1 6.123234e-17 -1078.2666 -1031.067)",
    className: "st1",
    width: 57.8,
    height: 308.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-891.8-36.7V-13h-256v-40.3h239.3C-899.3-53.3-891.8-45.9-891.8-36.7z"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: -1193.6,
    y1: 223.6,
    x2: -1077.7,
    y2: 223.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: -1257.6,
    y1: 146.4,
    x2: -982.1,
    y2: 146.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: -1239.6,
    cy: 223.6,
    r: 18
  }), /*#__PURE__*/React.createElement("line", {
    className: "st10",
    x1: -1239.6,
    y1: 223.6,
    x2: -1228.8,
    y2: 230.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st10",
    x1: -1239.6,
    y1: 223.6,
    x2: -1239.6,
    y2: 212.7
  })), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: -1037.8,
    y1: 223.6,
    x2: -921.8,
    y2: 223.6
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st11"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.4,40.2c-0.3,0-0.5-0.2-0.5-0.5V6c0-0.3,0.2-0.5,0.5-0.5h32.9c0.3,0,0.5,0.2,0.5,0.5v33.7 c0,0.3-0.2,0.5-0.5,0.5H23.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M56.2,5.7c0.2,0,0.3,0.1,0.3,0.3v33.7c0,0.2-0.1,0.3-0.3,0.3H23.4c-0.2,0-0.3-0.1-0.3-0.3V6 c0-0.2,0.1-0.3,0.3-0.3H56.2 M56.2,5.4H23.4c-0.3,0-0.6,0.3-0.6,0.6v33.7c0,0.3,0.3,0.6,0.6,0.6h32.9c0.3,0,0.6-0.3,0.6-0.6V6 C56.9,5.7,56.6,5.4,56.2,5.4L56.2,5.4z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 5.7,
    className: "st2",
    width: 33.5,
    height: 21.4
  }), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 31.1,
    cy: 18.3,
    r: 1.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.7,
    y: 12,
    className: "st1",
    width: 1.2,
    height: 15.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.3,
    y: 20.4,
    className: "st1",
    width: 1.2,
    height: 6.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.6,
    y: 11.7,
    transform: "matrix(6.123234e-17 -1 1 6.123234e-17 17.2225 61.9885)",
    className: "st1",
    width: 4,
    height: 21.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M50.9,18.2v1.6H33.1V17h16.6C50.4,17,50.9,17.6,50.9,18.2z"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 29.9,
    y1: 36.3,
    x2: 38,
    y2: 36.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 25.5,
    y1: 30.9,
    x2: 44.7,
    y2: 30.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 26.7,
    cy: 36.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 26.7,
    y1: 36.3,
    x2: 27.5,
    y2: 36.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 26.7,
    y1: 36.3,
    x2: 26.7,
    y2: 35.5
  })), /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 40.8,
    y1: 36.3,
    x2: 48.8,
    y2: 36.3
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      opacity: 0.25
    },
    width: 194,
    height: 198,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAADMCAYAAAA2yeyIAAAACXBIWXMAAC4jAAAuIwF4pT92AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAADZNJREFUeNrsnYuOozgQRW1C9/z/ 524n4NVKQfJ4q8plwDzS50ooZEIyaezDrSobJwSEEEIIIYQQQgghhK6uyPdEJyvR8QAA3RSgCBAI YK7RUSMAoZ0BSJ8ASOzwGvp9cKQzQIkngBFXHod+LyBp5XGXBCQ2QhEbvxfg/D6nSI2wpCsCUuvo rftr4EH3BSQ5oUhOcHYBJXaCQ+r01r9tAQZ9BiS1jp8cr7WEY4cAYl3hy44eDTi8wADJ74Ejf0yO 1zRgNoEydso/ahDUngMLUOQAaECUnxeLx1NzkFpYZIEgba2wAMhnAOKFQtu093jzlC4OUivNRuc2 OIHxOgq6ByC1MEra5gokkpNI/TMdAYgFRXCAMAj/3gKLB1J0HbfQIGmBIiqgzJXvsSncGjcAUUvI LRAGZd8LCoDcGxAvGPljnl/MAmCz8P9IOUkTMFscJFbCqsEAQts8oNQgAZBrAuKBQwKj3GIBSXjv D4KbbE7cx5VQhEY48u1ReS6BBSS/Aw4NjEl4HgsgPJA05yJ7JOkeOB7G48MARXMTKScBjutDIgFi ucWUdfypgGMS2tqCpHuSHhshGRQIrK0GiuUkAHJdQDzOIYExvbchg2SBQ2vrufh3DQ4XLHsk6XlH HRQ4ym1U9ktYvJCQtN+nauWBo9xeSh+YjO80Z+HVahcZV0ARgn+MowRlzDbtec1NqGp9RtWq5hqv Ao5X0f4aeNoFVPquVVj2mmqiwfFQ4PhSnkuOMjRAAhDXA8YDxyw4xlg4xwJJcIRvef/YNOVkjyqW BYfkHl8ZEF/Fc8tNrFALSO4DRzLgyF3jVbS95Aj5Zz4MSJqdowUQC4pghFUWHPn2XQBTglKDJDTk I+h4QEpIas6xbM+s3aMDkPQ+VoIkKYl7FZatIVZL/lGC8p3B8S04S+kkg3LCcJF7uUcSco7cOZ6Z ezwVJ5BAW/rbrPSP7tPda2XeoVLFKl3ku9g0N1neWwJCLnLP3KMEpIRjfD9KkUItjxkEF9GcokuZ 1zOF3ZOgfwuQ/FHcRAu1GBe5bhXLM+4hhVYSHMEJRw7JrDhIdFTemgCJTli8Jd4vxUH+vLfvAhCv i5CHXD//8LhHeRGU8o0yf3mEvwcTrX6ZjL6cepV5WwYKRyHU+lMAkjvJclyZiwzCVcY7LoL6AyI9 Ssn5AsiziBSksQ7JdfK+NRX9Yt6jH4w7QFELtYaig49CBUtzklEItYbsJA6h7Q5EdA4cuYOUyfnS 0V+CcySjHCyNk3gmth52w5Q1k7eWqEvVrD9GqFXmIla5F0CuC4jU0aWKlQTIq+g7r9A+TtZtunvL /ee1hP1ROIOUl/wxcpFH2Db1BB0LSQ0QKSlPwnFfQlhVK9po1U33vKzWMq9ncTjrxigtD5HKvpKL lCcmkofcJv+Q8oiHAkdSnGY0clFtxN3qs11m82oVo5ZQSxob0cZJvpx5CIBcH5Ay/5DGOZbXx8w1 vDO+a7O9D1+0wbOsjzX9pDYNpRw8XJOoo/NDLAkQLaySkvHWuXmeG+s2A7L29zyiM9SSZu5asGiJ OlNOrgOGln8snT8vx0YjrJL6xcMZWsUNfTjt7SChEmbVQBmU6taoVLzKAUOmnNwDkNxBtLAqh2N0 5hu1gcHN2rPMW6tqWTlJLUcpwzEAuScg5UILpXM8Kv2i9TbsuDXkXnvLrXfFdq+TPILvNl0txBoC y5SeDYaVoOfzo6bi+NlIvr0hlXcFzuZEfex04jwVLm3E3bMPIPcBJJ8omIdVQ5GTWGDUVt/s1sY9 VndvWZ9X+uNrK6IMhFi3CrFi+Hulkfzuvznog7/eZWl3rVr1AMQi2RN2RYeFepYuBZDr5iAhC7Xy pUSHxn7Q+lMZm2EZO560uBIW6WRFxW5bSnyA0g+MWIRUEiD569pytF6HqMFx2RCrtfLlGZHXwGmZ e4P6tmdtblPedrmDeEq0npviumk88ERaNzZZV//YuOEex7tIdLa/B4Zav+iSa1zFQSxorBPQ4jY1 KIBl35wjOmCpXRQ9P5p0Srv1qmK13Aa75pduW35HHSD6hVZWLhIcoHja3TuDfLfE/OgkPTR08DUO 4jnx6NhcRErc1zhIa9/56BBrrYOsueqg/UOtPEnXbkpqdZCPC7F6QrO3k6E+znGVdt9Fwwkdf00H 9oRYHvdB/cNpaw5UWJErrAm3bgfIGYkjoj1+JSCUc+8FRDz6qo+DIAQghFm0A4AgBCAIAQhCAIIQ gCCEAAQhAEEIQBACEIQABCEAQQhAEAIQhAAEIQBBCAEIQgCCEIAgBCAIAQhCAIIQgCAEIAgBCEII QBACEIQABCEAQQhAEAIQhAAEIQBBCEAQAhCEEIAgBCAIAQhCAIIQgCAEIAgBCEIAghCAIIQABCEA QQhAEAIQhAAEIQBBCEAQAhCEAAQhAEEIAQhCAIIQgCAEIAgBCEIAghCAIAQgCAEIQgCCEAIQhAAE IQBBCEAQAhCEAAQhAEEIQBACEIQQgCAEIAgBCEIAghCAIAQgCAEIQgCCEIAgBCAIIQBB6NcDkmhS 2gFAEAIQ8+qUHFcr3OQarpGMtgMQbB1gcJD2q37riUyKcyTlKgU058Eg7WttlzaAdogbjRcOn/Y6 ActnRPrxZV2iR7vfHpBUucJojSAdG4v9JACBmxwHTGrIQTzHngbNcMLVJTlfk/ZbTmACilMudt4L YK2tTwurejpIanCGlqtOy0kqQ6ryWEKtvhe/NSDV8pdaztMNnCuFWGsdRDoxsfj3SKh1GCxSm611 kNYQa3dYxpNgqHV07fVUOfHBAQvqC0lqaDdvu1sX1Y9K0rWT1wLD/O700QAkCSEWodVx7hGMtptX QJMMZ7kNIKmSW6TGK8xcnNBlf8ie5y4RMwiiIxdBxzlICYbUrrMBiuUcXWEZdzo5LXDUYJBO1qw4 yGwAQlJ+LUA0UJIBTnI4jlXo2ZyP9KpitYRL2kn8b5ve2+P9WIKwuMkgwBGpXp2aoAdHu5b7swJJ Sy5ziyTdE4sm5cRp+0O2n39uOTAIINcGZHLuTw3AhF5h1rjypKSKtdaStLkCRrkN4f+l2keWk8yE WLcIsZZ2fr23SdlmR9jdEm6Fte4y7nBS0ko4JsVq8+2VwZF39CFzjYEc5JaATBkoFiytwFgX69Or WC1JeA7KS9ge784/FJWo0j0igFwekCRcGF+VrQZLawK/e4iVGjqXlnNYUEzCiVhOzlNwjvwzl8Q9 CsdFwDgdlCS0WSqihbytl60GyqxAMu+Qk6QeDuKpWtXgyE/Uw3CO5f3L6yUgAUguB0doBMQDSpnE d61qjTuAsSbnkBxjFNxDc45HdgyA3AeQWWj/BYqf96aBUl5YW3KSQ6pY2pQNCRRvvrGAUXZ6yTkm wWGsBB04rhNiJSOKeBWA/AiwvLJHKyexwqxVrjI2/OFR2feEV5Ny5RiF0EqDY6wAgoNc10E8gDwF OH4qbjIHebzEStSbcpQ9y7yenOMlOEiZb+SfOWVwjEb+ASDXByQVHVqKJhY4/nlvP0Z+MjWEWoeE WJKjeMc9JiUhHxRAlveNWWg1Cu8h/7h3oi6FWc8Mjh/FRdaEWatgGXc+KVZivoxtPDMXqDnHV/a+ UXhfCQjjH9cARIv5a5FFGWb9Y0BSc5JDHMQaC/EODEqQSK4RlJOX5x4PJTmPgTlYVwFDS4xnIy+V Sr4eSCZHDuIBJe3lIOVtrLXEfOnMLyEsktxjee+rgMNyD0bQr+sgIbSF3hokLWGW5R7NrtJa5o1G Zau8T0ODJAZ9hHyBowytHgIgTDG5JyBWdfOpQPIM+hhJWc3yzPoNYecyb2gMs2YBkqjAUZ6ssRJa aeVd4LhPHiJVtMpQSxpl/zFcpDY1vlsVS3IOLczKXWRSrvRRKf+V4x2jAw7c4zNcRJvhq8FSS9Jb ppykPR1Eg8ULSVCOl8Y7NDjIPT43F9Hm6b0KMJ4KHNINedr3OazMq/3xJSTS8VbVanC4Rwj1cQ+A Ob6KZYVbnlCrDLm0gWbttt1a9Wr3JN0Ks2qQWMflM3SXAcGX0zm8eQeAnAeIJ8ySwi3pdohXkG+R qFWwNiXqa2+5ldacKpfiCU445iKcaoWDcY/rA7MFEuvGqTWDhN1CrFqZNxSVqRZApgoYWmgVcYzb OEoKviWBZgUWaTUUzzJRp5R5NThC+HshBSsEG8Lfi8FNAhQe5wCSezmI10mshT28dxZuXvVkjypW dEIiATJkx5ZuARy/DxJr1cU52CsyehZx6JakW7B4IZHGTFrAoGr1GWGWFxLt0bPyovV/dnUQKbyK Rsg1CzlDueDb3AAGVavPACQE/3oGtX1t3GOX363ca7p77ScG5qLDl2BF4ZjgdA6AuB8wnt+FqQGz dvG4JsWd3ivta53d4xLem6CA47NykhZYPD+lsck99uhgWoeNCixhIxQA8vk5iQeWEHw/j7A6Oe8F iNWxvfAAxe8NuVpg8TxugmPPzhYd4Vd0OA1w4CihofN7w6i0V8fu5SZr9j2fiT4HDo+rePc3g9Gz s3k6ddwAAYB8LiDejt4djCM6m3ecgvEM1OIsh4Cx6HHAH40boF7O0g2MMzpovOj3QveB5DAwzu6I AICOAOhjOirAoEsAcdeOCUAAgBBCCCGEEEIIIYQQEvWvAAMAeXHxapP1xDMAAAAASUVORK5CYII=",
    transform: "matrix(0.24 0 0 0.24 32.9706 17.6852)"
  }), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M72.6,56.5H39.8c-0.2,0-0.3-0.1-0.3-0.3V22.5c0-0.2,0.1-0.3,0.3-0.3h32.9c0.2,0,0.3,0.1,0.3,0.3v33.7 C73,56.4,72.8,56.5,72.6,56.5z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 39.4,
    y: 22.1,
    className: "st2",
    width: 33.5,
    height: 21.4
  }), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 47.5,
    cy: 34.7,
    r: 1.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.1,
    y: 28.4,
    className: "st1",
    width: 1.2,
    height: 15.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.8,
    y: 36.8,
    className: "st1",
    width: 1.2,
    height: 6.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.3,
    y: 36.8,
    className: "st1",
    width: 21.5,
    height: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M67.3,34.6v1.6H49.5v-2.8h16.6C66.8,33.5,67.3,34,67.3,34.6z"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 46.4,
    y1: 52.7,
    x2: 54.4,
    y2: 52.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 41.9,
    y1: 47.3,
    x2: 61.1,
    y2: 47.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 43.2,
    cy: 52.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 43.2,
    y1: 52.7,
    x2: 43.9,
    y2: 53.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 43.2,
    y1: 52.7,
    x2: 43.2,
    y2: 51.9
  })), /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 57.2,
    y1: 52.7,
    x2: 65.3,
    y2: 52.7
  })))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M73,14.3c0-4.8-3.9-8.6-8.6-8.6"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "75.6,13.6 73,18.1 70.3,13.6  "
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M23,47.9c0,4.8,3.9,8.6,8.6,8.6"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "20.4,48.6 23,44.1 25.7,48.6  "
  })))))), /*#__PURE__*/React.createElement("g", null, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "st11"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M192.2,40.9c-0.3,0-0.5-0.2-0.5-0.5V6c0-0.3,0.2-0.5,0.5-0.5h33.5c0.3,0,0.5,0.2,0.5,0.5v34.3 c0,0.3-0.2,0.5-0.5,0.5H192.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M225.6,5.7c0.2,0,0.3,0.1,0.3,0.3v34.3c0,0.2-0.1,0.3-0.3,0.3h-33.5c-0.2,0-0.3-0.1-0.3-0.3V6 c0-0.2,0.1-0.3,0.3-0.3H225.6 M225.6,5.4h-33.5c-0.4,0-0.6,0.3-0.6,0.6v34.3c0,0.4,0.3,0.6,0.6,0.6h33.5c0.4,0,0.6-0.3,0.6-0.6 V6C226.3,5.7,226,5.4,225.6,5.4L225.6,5.4z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 191.9,
    y: 5.7,
    className: "st2",
    width: 34.1,
    height: 21.8
  }), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 200,
    cy: 18.5,
    r: 1.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.6,
    y: 12.1,
    className: "st1",
    width: 1.2,
    height: 15.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.7,
    y: 20.6,
    className: "st1",
    width: 1.2,
    height: 6.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.7,
    y: 11.8,
    transform: "matrix(6.123234e-17 -1 1 6.123234e-17 186.0535 231.409)",
    className: "st1",
    width: 4.1,
    height: 21.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M220.3,18.4v1.7h-18.1v-2.9h16.9C219.7,17.2,220.3,17.8,220.3,18.4z"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st17",
    x1: 198.9,
    y1: 36.8,
    x2: 207.1,
    y2: 36.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st18",
    x1: 194.4,
    y1: 31.4,
    x2: 213.9,
    y2: 31.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 195.6,
    cy: 36.8,
    r: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st19",
    x1: 195.6,
    y1: 36.8,
    x2: 196.4,
    y2: 37.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st19",
    x1: 195.6,
    y1: 36.8,
    x2: 195.6,
    y2: 36.1
  })), /*#__PURE__*/React.createElement("line", {
    className: "st17",
    x1: 209.9,
    y1: 36.8,
    x2: 218.1,
    y2: 36.8
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      opacity: 0.25
    },
    width: 307,
    height: 201,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATQAAADQCAYAAACJI52/AAAACXBIWXMAAC4jAAAuIwF4pT92AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAD5lJREFUeNrsnQ1vo7wSRm2g3f// c2+TwHtXarTudGY8Noak6TkSSkLzycpnn7GNSQkAAAAAAAAAAAAAAAAAAAAAHkDmOwJAIxuyQFgA CO8FZZJ/wHcEgHHCOk1w+Uk+B2kB/A7ZHSq3o0WSOz4XuQG8jsR6//ZUQsuBffnk7wQA5wpt63ze 0witJrLc+HzKVIDnLR9bRBWR226xjZJCi8iOEhwAPE50tX3a/eFSGyGLHBBZ7vw7kgN4fnltDfe3 QHrrFtteMVjykYKyHueBkgOA44VWS1pb5220LD1MaDWZZUNgueG5CA3g5whtc/ZFnrtbassAmVnp SpNYDggukt4oQQHOKzFbUpgmMLnP++wsnpdbpNYjAk9mNYlFt9QhNqQGMF5mPSJr3VpL0WEJzUtI lsymwL4pmN4QGsBzCM1LYWvl8X2fl9DKZBZOaXvOq6yVl5Miq6lyG01tCAzgXMG1pLFVSEx73JrY QkmtJaFFZSYFNjn3pwa51cpQABgvs0h5qcmrlFguUtZavM/akBQPKTlT8qdmaDLzttmQXGv/GgAc L7RIIitldvu8vbfdUmDrZ1tflc/MSgkaKj2jQvOmaGibJi3t/uzIrta/1lp6Ij9AUmNKTS+RlTKb Cqnd95XtWEotK2I7dNqGlsq0/jEpsFkIbFb2SeFlI7HJUjcqK4QGCK1dZpbQZCK7GTK7396MdlhK LRvfJZzSlg4RaI9zQGaLIrJFeZ6X1rTyE6EBHCs0q8SUiexW3L8WMivb7E35zLXwR230c1hCq6Wz mswWIbHFkNxspDVZfvaWngCwr9TU+smuhdTuyewq2nDtM1dDXOHSsya02onnXv+ZlJm3WSnOKz97 hIb0AFn1Cc2T2T2RXUU6u0stG58lS1qt+kotgusZFKhNoi2Fpsnr7XMrH8+G4LzyMyVGPQFGC29z hGaVmaXQrkab9T5vU1yyGR4aMspppTVPZrOS0u4yezfkVgrOkhpz0wDOldnWILNLUGb3bRKPrZQW SplLY3kWOQ/TSmmlzMrbUmpvSe9bqw0Q9JSfAOCXmckpNcvt4qQzTWTle0qhbZWU5qa1nlHOWjrT UtqiyOxdSO1dSE2OgrakNKQG0C+zaDq7S2z5lJqXzrT3mYv7VkBqGiDonVhryc2SWbm9O9ubIjUr pU3i8xEZwBixyXS2JX1EsywztVkJKfmTby2pee4Z2ocWKTU9mb2JhPanuJVlaGtKI6EB7E9orens ooSOFJTZWpSdk5HUTlngsbX0XER/mZTaH6UE9VIac9IAju9D8/rOynJzVtpjcoR4b883xRdrajud cYsILTf0n2lzxLSRzllJaX9ESivLT20ax5y+n2ZFHxrA+D40rdysTdHIFZFdU/vZQE39aMuAg1I7 Y0ArP8s0Vortj1J2Lun7KVJeQkNkAH1isybT3pRyUw4CJOW199eU7fhq9Ld5pzYeVnL2nCkwK/1o S/o+2qn1p3mTbWsJrfb9AX5rGotITTv5vExZsyg1U/E6+fylUWrV0nKP0LylsVumb0iZeYMEZdlZ nklgJbSI0JAZILWY0KyEVk7RmJ3+slJmb0KCteXCrJIzR37HMvBgtZaecoDgLelz1Eqze0Lj6lAA 7TKrra5RTteYRb9ZUpLZmr4PGFiLTkx7S8xRQotevckaHJgDJei7049mjXQiM4BxUtMWbLQmzd6U /jJtNZ1IIuuW3KiE1lN+eqtxyCkei1G3T6ltUACpATKr95/J05MsmZV/fxP9ZZbIIqcxnpbQtDQU lZlVflqDBjK9eUJjpBNgn+i85YK0czO1PjNrKbCpo+9MOsaauvHlb4uTYnKD2CJlqCc2bRFIKbVy YGDPSCcA+FKTI5xamSmnZVwDiaxlmsbDSs5Iaosmttmpv5dKHY7UAMYktElJYDKZLen7hFmv89+7 TOUuiY0U2t7yU1uy2ytNax2LSA1gf7kpl/FJSjJbK+13T0LrbrvLwQcsKrmc9IulWFeKaulDQ2wA usg8qWmrX2zp3+oYt1SfjhHpIxvKslNSKcUn3Vpis66aHkl2nM8JMF5qd5mtQnJToIysXVe3dgHx bHhmuNBaTyuqDRxMzu3kJLqc2gYFkBrAd5llR2hy31TcRsKINaWq5oaaX4Zexq4lvbUmulpCy4bx mbYB0NdOpdzK23IZnyl97U/z2uTUkbiGlqDLCQfM+vJeZ352JGYd1NqSRwAQnM9VVD5boHxMlXZ9 2tk7I0c5a2ktB/7WcqBqUgSAepuVCU2KLxo8om08ksoeOsoZ+XI5UDtnZ591MFPwvQFAT2pe+ZmD 7dELE9G0NqT8nB70P0NEVKnxIA6doAfwC5KadwHxSPtLKX6N3FPa4/KAg5icA9NyoFpGNZEbwNdk VraNTXkcbX+R9nxa+5secEBbBdQScw8dQQF4wWS2p43lzvb9UkKLiCgqw1HPBfiNYhv93IcPzk0v 9I/BGQIA/e3oJbpqph/8j4C0AGhnL5HQnqZmB6D9vL7Q9pxVTwIDeO0Ed9iqG9PJP771ICE1gOeX 2RGDer+25AQAQGgAgNAAABAaAABCAwBAaACA0AAAEBoAAEIDAEBoAAAIDQAQGgAAQgMAQGgAAAgN ABAaAABCAwBAaAAACA0AAKEBAEIDAEBoAAAIDQAAoQEAQgMAQGgAAAgNAAChAQAgNABAaAAACA0A AKEBACA0AEBoAAAIDQAAoQEAIDQAAIQGAAgNAAChAQAgNAAAhAYACA0AAKEBACA0AACEBgCA0AAA oQEAIDQAAIQGAIDQAAChAQAgNAAAhAYAgNAAABAaACA0AACEBgCA0AAAEBoAIDQAAIQGAIDQAAAQ GgAAQgMAhAYAgNAAABAaAABCAwCExiEAAIQGAIDQAAAQGgAAQgMAhAYAgNAAABAaAABCAwBAaACA 0AAAEBoAAEIDAEBoAIDQAAAQGgDAiwtta3ze1vg6ADiP3nZ6eHueDvzBW+cPQGYAP09qZ/nh5UvO 7ez/BQBeUEwv0X6mH/wPgLgAaGcvkdC2yj5kB9DWjrZgO0NoAfsf0amI1ADObUsPH9SbnuBARtPW 1vi3+2PEBuC3id42tnW278NYnijiejLSbv9uubgtX5dJawC7Akak/UVFdlr7mx504HoOVO1/j41k BtCd1LYBVVBrmnvKhFaTx9YorBQ4QFpCK1+fSWYATUFja0xotTYbbf8tLjlcaC1fbgv8bUvfJ91p f9Pe05JbUkpQAEpMv/0lY1+krba2/xavHJ7QWr7Q5hw860D93dbP8rh8LEtmq0+NpAbQltDubWxV 2uHWGDy2ig+eruSsRUbvB8oDtSoHVDuoWRFdrfwEALssLG9XR2Ke6NZAWz90JsLSeBBy40Hy5LY6 t9ZBzJ/bqsgqG/tIZwB+e7WEtjrhYnVkVj5ucUNP1bc7oUUSV3RbgwlNCu3+WZMQbXZEBwB1mW2O zLTNare1MnVrcMnDSk5Pfpsjq7/7bp/3b+L+9LndxPuWMssVqQGALTYrkKxGm7Tue6Lb0oGrbIwS 2tYhL23TDkops2yIEpkBHCc1KTS5ee3XS3Q1yT10lHMLiK0ms3K7/n+bC5lJoW1i/4TMAIZKTSs3 722zbKdXse9WkZuV2iyXDBGaN/3B++BIf1lNZNfP73QtpCXffxYyI6EBjE9opYDKdnpRZHZ10ltP QuuW29Lx4/eWmVJi0vYXI5mV7yGFFpUZooPfLq6o1CyhXYXULkZauwbkFuljs8SmjqAuAw9WRGq3 SnS9igRWHtxF9K1pCc2TFjIDpFbfb7VhLXhExOZJbfhgwTJQYJbUrA7F8kAsRTKT/WUymc2KzJAa wFiZyTa8KkL7+NwuitBqYos65BSh1SRXKzNLkc3p6yCAVmbeimRmCY1yE2BM2Sn70Uqhlf1oH0Jq mtxqgwVDp3IsjQchp7aO/1WpvRdxW8pMyvH+2iV9H/3sGeFEaoDMYv1ocqTzZpSdNaldgv1p0Um3 28iEtom+LU9qN+cglCWm1g+2Fv1mS5HkrITWIjUA8GVmJTQZTi6FxP6nlKC1MtSSWauMh5acraXm PapORjIrX7uIslTKzEtoiA0gntpqJ6h7bVmT2ochtJa+tGElZ20pHiuV1QYDvGkZSbz2TZGZLDcz MgM4RGrWSKfWF/6hbBdRgtbKzhaxbUcltGgf2lUkMq/MlGcMLOn7mQPagABSA9gvs2jVdTVKz1r5 GZ3K0fr9m4UWPb2pPAdTE5k2NaN8fXnGgJbOtHITkQGME5tXdpajnVJqH0mfzhEpPYfMS1safnDt NKio1Kwy836g3jrSGWUnwNg+tJaUpiW1S7Af7Zb86RtNgls6Zaals3LxRU1q2XjvVfSbRdJZTv4c NGQGsL8PrUxp3nnYpbQ+DLlFZbZrxHPpEJlXdmo/PAdlthQJzZJZJJ0hM4A+qfWkNC+pXXf0oXWt YLtnCW4vpd2SfVpSKsxflppL+jqBdnb635AZwLlSiyw0YZ3XeXFSWnSkc+gS3HJC7V0eNal571f+ kLlSauaK0KIyQ3hAadlXflqlpzxxXVtwwju/s2UwYHcfmpbKshNLS6lZ76cdlLmQWnlGgJQYc88A zpGed26nJrWrkdisxw+fh6bJrExb0ffQ0tkULDNbV9cgnQHsS2mt52xrq9vWlvCuzUEbeuqTl9Kk ydfAe62G0KZAmVkmM4QGcI7QUrLPDJJJbU36Chva6KYsOSMXMt4ttEhKS+nfemVrJZ1Nitm9VFZb JigqKoQGCG1s6emtTm1d+GhVZFbrRwtfQKV3Yq12hfLyw1ZDZuUFTrTltGslJqOaAOfKL3LNXS2x Ra4CFbloShO9FxrORlq7C0pKTf74UmryZPPI5FmEBnC+0FLyLxi+OdKy7teuI9AkuD2DAmVCy0Jq WZSf5RSPLMSWA6mMUU2Ax5aokaTmrb7TcjX1bpadP9aSWim2VEhJprs1+f1kLTJDcADjBBaVWqok Nktgq/EeqTed9UrAW65Hk1HPVisvERrAY4XWmtoiS2zvktkeCdTWIIvILSV/OkZLmYnMAI6TWq/Y UqpfI6Ams1OEpr3WS1a1MtITmvdZAHCu4CJLDtXKU+u5u2Q2Qgw1qUlJtaQwhAbws4RWS2+tpWXz AMEIMeRAOZo7/259R4QG8LgSNCK5qOiin3Ga0CLSia77j7wAXkNyLXLbLbKjZNEitr0CQ3QA54ur 5Xmt5eTuq6cfJYWIqBixBHht8W2dz+tmPviHIi2A353kev/2VAmt9XMQHMDvKFO3Iz/8ESLJP+A7 AsA4KW1nfbFnkAXCAvjdwvtVMkF4AAgLAAAAAAAAAAAAAADgH/8JMAAt6R2R6NORpwAAAABJRU5E rkJggg==",
    transform: "matrix(0.24 0 0 0.24 202.2961 17.0908)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M268.6,56.5h-59.1c-0.3,0-0.5-0.2-0.5-0.5V22.1c0-0.3,0.2-0.5,0.5-0.5h59.1c0.3,0,0.5,0.2,0.5,0.5V56 C269.2,56.3,268.9,56.5,268.6,56.5z"
  }))), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 242.7812 42.8441)",
    className: "st7",
    style: {
      fontFamily: "'Helvetica-Light'",
      fontSize: 11
    }
  }, "+"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 252.7383 45.2787)",
    style: {
      fill: "#5BCF65",
      fontFamily: "'Helvetica'",
      fontSize: "13.7481px"
    }
  }, "\u20AC"), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M214.9,51.1c-0.1,0-0.2-0.1-0.2-0.2V27.8c0-0.1,0.1-0.2,0.2-0.2h22.5c0.1,0,0.2,0.1,0.2,0.2v23.1 c0,0.1-0.1,0.2-0.2,0.2H214.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M237.5,27.8v23.1h-22.5V27.8H237.5 M237.5,27.5h-22.5c-0.2,0-0.3,0.1-0.3,0.3v23.1 c0,0.2,0.1,0.3,0.3,0.3h22.5c0.2,0,0.3-0.1,0.3-0.3V27.8C237.8,27.6,237.6,27.5,237.5,27.5L237.5,27.5z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 214.9,
    y: 27.8,
    className: "st2",
    width: 22.5,
    height: 14.4
  }), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 220.3,
    cy: 36.3,
    r: 1.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.1,
    y: 32,
    className: "st1",
    width: 0.8,
    height: 10.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.3,
    y: 37.7,
    className: "st1",
    width: 0.8,
    height: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.9,
    y: 37.7,
    className: "st1",
    width: 14.4,
    height: 2.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M233.7,36.2v1.1h-12v-1.9h11.2C233.3,35.4,233.7,35.8,233.7,36.2z"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st20",
    x1: 219.6,
    y1: 48.4,
    x2: 225,
    y2: 48.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st21",
    x1: 216.6,
    y1: 44.7,
    x2: 229.5,
    y2: 44.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st22",
    cx: 217.4,
    cy: 48.4,
    r: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st22",
    x1: 217.4,
    y1: 48.4,
    x2: 217.9,
    y2: 48.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st22",
    x1: 217.4,
    y1: 48.4,
    x2: 217.4,
    y2: 47.8
  })), /*#__PURE__*/React.createElement("line", {
    className: "st20",
    x1: 226.9,
    y1: 48.4,
    x2: 232.3,
    y2: 48.4
  })))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M242,14.5c0-4.9-3.9-8.8-8.8-8.8"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "244.6,13.7 242,18.3 239.4,13.7  "
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M191.9,47.7c0,4.9,3.9,8.8,8.8,8.8"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "189.2,48.5 191.9,44 194.5,48.5  "
  })))))), /*#__PURE__*/React.createElement("g", null, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    className: "st11"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M359.5,40.9c-0.3,0-0.5-0.2-0.5-0.5V6c0-0.3,0.2-0.5,0.5-0.5h33.5c0.3,0,0.5,0.2,0.5,0.5v34.3 c0,0.3-0.2,0.5-0.5,0.5H359.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M392.9,5.7c0.2,0,0.3,0.1,0.3,0.3v34.3c0,0.2-0.1,0.3-0.3,0.3h-33.5c-0.2,0-0.3-0.1-0.3-0.3V6 c0-0.2,0.1-0.3,0.3-0.3H392.9 M392.9,5.4h-33.5c-0.4,0-0.6,0.3-0.6,0.6v34.3c0,0.4,0.3,0.6,0.6,0.6h33.5c0.4,0,0.6-0.3,0.6-0.6 V6C393.6,5.7,393.3,5.4,392.9,5.4L392.9,5.4z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 359.1,
    y: 5.7,
    className: "st2",
    width: 34.1,
    height: 21.8
  }), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 367.3,
    cy: 18.5,
    r: 1.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.9,
    y: 12.1,
    className: "st1",
    width: 1.2,
    height: 15.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.9,
    y: 20.6,
    className: "st1",
    width: 1.2,
    height: 6.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374,
    y: 11.8,
    transform: "matrix(6.123234e-17 -1 1 6.123234e-17 353.3318 398.6873)",
    className: "st1",
    width: 4.1,
    height: 21.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M387.5,18.4v1.7h-18.1v-2.9h16.9C387,17.2,387.5,17.8,387.5,18.4z"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st17",
    x1: 366.2,
    y1: 36.8,
    x2: 374.4,
    y2: 36.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st18",
    x1: 361.6,
    y1: 31.4,
    x2: 381.1,
    y2: 31.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st19",
    cx: 362.9,
    cy: 36.8,
    r: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st19",
    x1: 362.9,
    y1: 36.8,
    x2: 363.7,
    y2: 37.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st19",
    x1: 362.9,
    y1: 36.8,
    x2: 362.9,
    y2: 36.1
  })), /*#__PURE__*/React.createElement("line", {
    className: "st17",
    x1: 377.2,
    y1: 36.8,
    x2: 385.4,
    y2: 36.8
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      opacity: 0.25
    },
    width: 199,
    height: 201,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMwAAADQCAYAAABLNo4SAAAACXBIWXMAAC4jAAAuIwF4pT92AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAADlJJREFUeNrsnYuO66wORiHJ7P3+ j3umbfjPlhoJMTY2uZLO+qSo93YGWHy2Q2kICCGEEEIIIYQQQgghhJBbkb8TdaAEMACBPhCoeJPP BSiA6AKg2NFnAQVaA0f6JGDiAY+h3w1JuhKeePL7xpXPQwAj3Z/OBiee8H41SLYCA1ifmat4QPDA k3oGpgZLbAAmAgYgOe6Trh8OTTwYFAkaDzwRiH41HGkFJOkMt4k7v94DSmwAqRUidD9gLKdIKy9b cp5TgPHCEpX7ovO5APN7gUmV+zzP3R2aaWdYLAiiAkw0gNmzUID6SPS9LiIBUt5X++xYPC9ugWba oUEsWNYea8ABmnvlK15QPIcESVSgOTUks/KU8vogwDAYt63wDWA+D5iai8zG7fK+Wji3KTSLB8AS DUAG47bXdQDk3gC1uMlcACHdttxnF2imnRrCAmUwrksQrQnTUP+weMIvCY4ckpiFWXP2PnNjHnVo DmNVwYIBi3SMAjAexwGYzwDG4yg5LK/35TIOckDm97iZhc+MShGgObfZ4jCx4jD54B8VQEYFGo/j rA3NgOucClhrKFZzlByWIYNmuS8fEyU0UQDnlLJydIKiwZJfjpXbJUCa42juBjD9AVPCogFTOspL gWW5fCl9mkMTlb9ltcu0Okx0gBIrkEjHJDy35jZSeAYw9wJGC8FKR3ll158ZLHn/v4TPnLNxOCt/ 0yq3WROSxUrSL+UoJRxT5fZyXy2/oWr2OVWxWp7yzKBZnOVZjAfrM2cFjNWh2bQREM1pJGgm4ygB 8kCzBhigus5dghOWxVGehbss0ETls8qQT4pEwhaA1lbJLHgGxVn+HV/vo7xvUhynFp4Fqma3qooF ZxiWA/NU+r/2eUkYk0kZu4dWyawTi5a7fBXHJNz2QMO5mXvDkhpgeThhWY6huK25TAgH5DCxAaDB yGFKOP4It3Owxgo0y+cF8plb5S2hEorlx6PiLhIo+XsOQlEhOtzE5TZrysrePGasuMyf7JDgkZym 1WWAph9YvO6yQDK9oam5i/Q+Y3ZdG5ubCgCtOYxmb15YNGgkcMpiQP6+seIygNIfOKW7JKUilodh o5Kz1k5uatDUJv9Tz/TXcpgaLF8FNH8LcCRoPC6Dw/TnMK3u8hD6OzhhmbOwbFCc5rAz/bERnDU5 zALLX8VxrAIA52TulcMkR6I/CZFEDZhXNjZewhicG8dy2uowW8/DDAI0fwxwyiKABI0UlgFNvzmM FI5ZJeRogPIM7StDNuUxW5f3e8Dx5jF/i8syNCvXoNVOYgJKH+BoJytfQjhWJvlSJWx5TT6Onkq+ E428e/eQbIvjeM7ye8Izq2JmOcyWUBP53cQDjbS4MneJMnoI2evK50+N0DSHXluBsTausEIyKSyb ws9zMn+EIz8vM1UcxgMMsJwHTW3tWF4dm7JEX8tXcli+Csisr4ZoIVlcUymbdm7AWsVMWy5jQVO6 jFReblm9DDTHwmKtTs7LyWORtwTBWWahIFCG51bldDftXVb25DKeMO2PEZa1lJaBpR9opC+EaScl X0K+MgV9BUjLbkSXAOMByCo1Swsza+vOpFh3aEz6gebccCyEn8tXXkY17JWFXhYoVhh2isNER4Jv OY31Xf4xyN+NkcCR1pdZy/0Bo88K2RzktWFSzjIpY2VYkbuU41UrLVcLAnuEZN4wzYKnbBgNIGsh JrD0B01ZIRuMatikVM9ak3trvF4Wklmuo+0gMzrCNGmGGUPbIkx0rcMMgoOUzjKFnycka8m99i3c uDckewPjCc+sEE3bRaa2F0Ct5g40fYVj5TJ7rRrWsqNQi8PEnoBZW02TXEfaDKO2y4w3hwGc8woA tRxGWhs2hp9rwrx7OhxaQt4TmNqWR95Sc23rWI8jeXMYYLkemgWWuYBocIRZ3l1RY8O4PA2Y1mUn te8j1DYlrzWctuVsLRQDmuNhiRVgtJxmcPa9dvrAM85qY/WyvZVbqmca+bWGGgyHIn+5VlGAJ7/M l9kPRT4zOCbOFsc4NESbTmpE7R+yfo3M+okMK+nHZc4NxULQz2cMBVAtm87Xdjw9tY+nA8EIwf42 ZG2Dc0/jWdChc91FcpgSLO8k6R0vHlfprkoWG8Cx8hrtPu9vYpK/XOs0tfBs6w8De8bSoeHZcOFs 5AEhNDbsoSetUNOkGUPbRBiMiTCEDqqf00UNG5zVrBjaHCaQw3STw0g5zZpJMvQCyxUOE1YO8Bbr PrVqgjZFBB4Qugqxh4sbek2SHjeAic6bBPd4bneFnOHDOogz/P30yUeGxcPNOwYo6DOAOSgnQvRF 18BsWeyGg+BAZ421bh3mtokeOh2Wbn8Ve6CvEAIYhAAGIYBBCGAQAhiEAIYmQAhgEAIYhAAGIYBB CGAQAhiaACGAQQhgEAIYhAAGIYBBCGBoAoQABiGAQQhgEAIYhAAGIYChCRACGIQABiGAQQhgEAIY hACGJkAIYBACGIQABiGAQQhgEAIYmgAhgEEIYBACGIQABiGAQQhgaAKEAAYhgEEIYBACGIQABiGA oQkQAhiEAAYhgEEIYBACGIQAhiZACGAQAhiEAAYhgEEIYBACGJoAIYBBCGAQAhiEAAYhgEEIYGgC hAAGIYBBCGAQAhiEAAYhgKEJEAIYhAAGIYBBCGAQAhiEAIYmQAhgEAIYhAAGIYBBCGAQAhiaAKE+ gUmNz0uNr0P31do+T58ETMqOrQ2Ifh80Z421XxmSpatnHvQ7+mK4eacABn0GMBvi14TLdNMnydln ANNRogc0105gW5/bXQFo6KRxvW6RGh8LZyWDvxyU1DDQPY91mxNNndl2bbBLl/+OmF3mr4u4TVeT oacvvaBc1pdDB7C0NJ41YyWcpRunSTtEBK1udBuHsQZnagQiOBpNcpj89RFn6So3Tc4+DY1ApQ3j 8hJgUuOsYz2Wws8TUdJj0ntq8AQhREPHJftWf1l9mxrGixec7nOY1OA2VuP9O+Z3CJnfLsNKLafB aa51mKW/ZqFPU+MkmYyxdbukP1VsNFWgmZVG1Bo6CiBZ4Rk6P9EPRf95+7d8rjXZnpK7TisaJjY2 XK0xrYaahYaN72MWYIjKfbjLtQUdqV9nBaTZGBut42zXMG3a0Dge8lMlvNJmGKlRZwGY5bOGAuRY AQmdD4u3X2djorTCuNQwLrvMYYIBkNSAr+wyvz68j1fxvjks0YAGXZe/lIP/VenrVzEW5orrnLZK +agqmeUqtUNqqByWQQERWO4DTQlMedTGQs2RLIi6q5IlAxzNjl9KAz7/f4wFLFFwl+X+AVi6hkaL Jp5Fnz+L+14GPJrrHFYAmHaEZK3DSLBM78vSWZb3GQtYcJj+HSYf4Hl/PwRYnhX3WeMwu8EzGdUw 7XyGJwybHZBIM8z4bkTJWfL3KIHxwgJI+yf6Hmg0YJ4FNA/FbZ4OeDw5jgaOa0X0tHMDeqCRHCVv rLFwkLzBJyG3KXOYGhTAcg402oQqhWR533vAqUFzeDFg2hmQ5KiMSKCUwEQhDMudZRRgAZq+YUmF w8xC33+/j4cAjAWOdzx2kfR7ZpNZAebx/ju0algJ3JBBNVSqZMDST1hW5jE5MHke811AI8FjFQMO LTVPKxombkzuc0jKEEyqhi2vm4Tq2ZoKGdAcD4unUqaF5BY0D2c+4z2pmY4ARioI1MKzWqNo+YpU Dfv32q/ws9Q8UiG7daXspUyijwyS/wkhmhWmabC0wn5YSNaSu0jADMKgD0JiOGVwlflLzWEA5zrX sRZgavnstwLNtwJMSy5zSkjmcRRvZawEZVCqYXNWFZNgGRz5C7D0BY2W20o57bdwPIoQzQrLWsBJ ewCTnIPOW0J+VkAJwuzzFIAZDGCApj9YgjGhSsA8CnBq4Zm31LxHXrZ7WblsiEEBpXZS8iWEYlOQ y8l5OAYo/YJTC8vyalkJzXeQy82e0OyQ8zLTykYIijukApYaNFFxqLXuQljWdw7T4jKS0zycecwr 1MvLmwBqKSu35jEaNLWTkkujfRV5i5S7SO4CLH3nMLnL1FZ/PIQiwEOBxoJl14rZtAKUUHGWfNZf /oGoVMKCMNMsrvKswOJxF2DpA5o1LlNzmueGHGaXb2BOG2YPC5ocmKi8rmwwqyomlaGB5Z7QzI3Q 1NadacDsvkymNYeJDcn/qzKApQYr85ahEoptCcMAav/Qa014Zn3j9ikUA7SjdBkvHIfkMJ4ti0pY 8tzi5XSXMYPGAwt5y73zGQuap+I42u3Lz8OsKQDMjsEruUvuKE8jDGtdnYy79OUyrSe7pW9nWl9x ts7BnLY0RttVckngBwEcrbEkYEpniUaiDzD3BEYrACTBaeYgr1CWqmNlSObZKPAQYHJXKa9L7jEI 0JTfvhuDvtlFCcleoRjAnA9MS2hmrXaXQJoFWKw8ZvUGGVvP9EelElJCk//RQ/bYmD235igxsDvM J1bNrBBNy2+8e5rtvnvMtAGQPDSTHEdyGqlRPI5CGfkzgQnBv9GjBFEyYNFCwUOrZFuseVYgW67P TkehKvY7qmYex1mzG+ZuihtfI8325XUJhsG4Xb6HFxYA6j/HsaAJhuNogFgbl292ly0DzIImOB2j NU8BmM8FptV1PF9B3hWWvYDxQBMMKLaCAiz3q6StAScE/8bjGiyXAFODpgZMMOBoAQVAPgMgz1cC rPCtJbHflNNsHXReaFouAQZgWn/rNJwBy16DzsolvK7RCgfAfGZeUxv03l9j3nU5zFGDrjaoW75z DxxA1FIwqOUqu4Fy1ED0DPY9E3hA+owCwJZCQTgLliMHnBcEKl5oLTAtz9tN48H/OPsco72daO1j XTvMms8CILQGglN/IfuqQRpv8neivnKbSyDpcSACBOoSkLsOVIACCIQQQgghhBBCCKHj9J8AAwCZ aBZ/9bv5ogAAAABJRU5ErkJggg==",
    transform: "matrix(0.24 0 0 0.24 368.3761 17.0908)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M408.9,56.5h-33.3c-0.2,0-0.4-0.2-0.4-0.4V21.9c0-0.2,0.2-0.4,0.4-0.4h33.3c0.2,0,0.4,0.2,0.4,0.4v34.2 C409.3,56.3,409.1,56.5,408.9,56.5z"
  }))), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 385.9121 46.0277)",
    style: {
      fill: "#5BCF65",
      fontFamily: "'Helvetica'",
      fontSize: "17.5919px"
    }
  }, "\u20AC")))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M409.3,14.5c0-4.9-3.9-8.8-8.8-8.8"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "411.9,13.7 409.3,18.3 406.7,13.7  "
  }))))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M359.1,47.7c0,4.9,3.9,8.8,8.8,8.8"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "356.5,48.5 359.1,44 361.8,48.5  "
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuleBooking);
export default __webpack_public_path__ + "static/media/rule-booking.fda007dbeaa9aa497b4135dd1027cf57.svg";
export { ForwardRef as ReactComponent };